import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {TeamMemberWithDayOffCountOutput} from "../../generated";
import {useStore} from "../../context";
import ResourceGridView from "../../components/grid/ResourceGridView";
import {DaysOffManageListStore} from "./store/days-off-manage-list-store";
import {useHistory} from "react-router-dom";
import {TOTAL_DAY_OFF_PER_MEMBER} from "./store/day-off-user-store";

export const DaysOffManage = observer(() => {
    const {uiBus} = useStore()
    const history = useHistory();
    const [store] = useState(() => new DaysOffManageListStore(uiBus));

    return <div className={'dashboard'}>
        <ResourceGridView<TeamMemberWithDayOffCountOutput>
            gridResource={store}
            onRowClick={(item) => {
                history.push({
                    pathname: `/day_off_manage/${item.id}`
                });
            }}
            columns={[
                'id',
                {
                    name: 'Member',
                    value: (entity) => entity.username,
                },
                {
                    name: 'Approved days off',
                    value: (entity) => entity.approvedDaysOff.toString()
                },
                {
                    name: 'Pending days off',
                    value: (entity) => entity.pendingDaysOff.toString()
                },
                {
                    name: 'Declined days off',
                    value: (entity) => entity.declinedDaysOff.toString()
                },
                {
                    name: 'Days remaining',
                    value: (entity) => TOTAL_DAY_OFF_PER_MEMBER - entity.approvedDaysOff,
                },
            ]}
        />
    </div>
})
